export const SET_IMPERSONATION = '@impersonation/SET_IMPERSONATION';
export const CLEAR_IMPERSONATION = '@impersonation/CLEAR_IMPERSONATION';
